import { useState, useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

// IMPORT YOUR LOGO
import lrqaLogo from "../assets/clients/LRQA logo.jpg";

const LRQAInspectionReleaseNote = () => {
  const [loggedIn, setLoggedIn] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const today = new Date().toLocaleDateString("en-GB");

  const [form, setForm] = useState({
    project: "",
    irn: "",
    poRef: "",
    date: today,
    client: "",
    lrqaRef: "",
    supplier: "",
    location: "",
    contact: "",
    concessionsApply: "NO",
    completeOrder: "NO",
    inspectorName: "",
    signature: "",
    equipmentRows: [
      { poItem: "", qty: "", desc: "", tag: "" },
      { poItem: "", qty: "", desc: "", tag: "" },
      { poItem: "", qty: "", desc: "", tag: "" },
      { poItem: "", qty: "", desc: "", tag: "" },
      { poItem: "", qty: "", desc: "", tag: "" },
    ],
  });

  const pageRef1 = useRef();
  const pageRef2 = useRef();

  const addRow = () => {
    setForm({
      ...form,
      equipmentRows: [...form.equipmentRows, { poItem: "", qty: "", desc: "", tag: "" }],
    });
  };

  const updateEquipment = (index, field, value) => {
    const updated = [...form.equipmentRows];
    updated[index][field] = value;
    setForm({ ...form, equipmentRows: updated });
  };

  const uploadSignature = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (ev) => setForm({ ...form, signature: ev.target.result });
    reader.readAsDataURL(file);
  };

  const handleLogin = (e) => {
    e.preventDefault();

    if (email === "qnexservices@gmail.com" && password === "Qnexa@123") {
      setLoggedIn(true);
      setError("");
    } else {
      setError("Invalid Credentials");
    }
  };

  const downloadPDF = async () => {
    const pdf = new jsPDF("p", "mm", "a4");

    const c1 = await html2canvas(pageRef1.current, { scale: 2 });
    pdf.addImage(c1.toDataURL("image/png"), "PNG", 0, 0, 210, 0);

    pdf.addPage();

    const c2 = await html2canvas(pageRef2.current, { scale: 2 });
    pdf.addImage(c2.toDataURL("image/png"), "PNG", 0, 0, 210, 0);

    pdf.save("LRQA_Inspection_Release_Note.pdf");
  };

  return (
    <div style={{ padding: 20 }}>

      {/* LOGIN */}
      {!loggedIn ? (
        <div style={{ maxWidth: 350, margin: "0 auto" }}>
          <h2>Login</h2>
          <form onSubmit={handleLogin}>
            <label>Email</label>
            <input
              type="email"
              value={email}
              required
              onChange={(e) => setEmail(e.target.value)}
              style={{ width: "100%", padding: 8, marginBottom: 10 }}
            />

            <label>Password</label>
            <input
              type="password"
              value={password}
              required
              onChange={(e) => setPassword(e.target.value)}
              style={{ width: "100%", padding: 8, marginBottom: 10 }}
            />

            {error && <p style={{ color: "red" }}>{error}</p>}

            <button
              style={{
                width: "100%",
                padding: 10,
                background: "#007bff",
                color: "white",
                border: "none",
              }}
            >
              Login
            </button>
          </form>
        </div>
      ) : (
        <>
          {/* ================= PAGE 1 PREVIEW ================= */}
          <div
            ref={pageRef1}
            style={{
              width: "210mm",
              minHeight: "297mm",
              padding: "15mm",
              background: "white",
              margin: "20px auto",
              boxShadow: "0 0 5px rgba(0,0,0,0.3)",
              fontFamily: "Arial",
              fontSize: 13,
            }}
          >
            {/* LRQA LOGO */}
            <img
              src={lrqaLogo}
              alt="LRQA"
              style={{
                width: 120,
                marginBottom: 15,
              }}
            />

            {/* MAIN TABLE EXACT LRQA */}
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                border: "1px solid #000",
              }}
            >
              <tr style={{ background: "#D5E6DE" }}>
                <th colSpan="4" style={{ padding: 10, fontSize: 16, border: "1px solid #000" }}>
                  Inspection Release note
                </th>
              </tr>

              <tr>
                <td style={{ border: "1px solid #000", padding: 6 }}>Project Name/No.:</td>
                <td style={{ border: "1px solid #000", padding: 6 }}>{form.project}</td>

                <td style={{ border: "1px solid #000", padding: 6 }}>IRN No.:</td>
                <td style={{ border: "1px solid #000", padding: 6 }}>{form.irn}</td>
              </tr>

              <tr>
                <td style={{ border: "1px solid #000", padding: 6 }}>Purchase Order/REF DOC:</td>
                <td style={{ border: "1px solid #000", padding: 6 }}>{form.poRef}</td>

                <td style={{ border: "1px solid #000", padding: 6 }}>Date:</td>
                <td style={{ border: "1px solid #000", padding: 6 }}>{form.date}</td>
              </tr>

              <tr>
                <td style={{ border: "1px solid #000", padding: 6 }}>Client:</td>
                <td style={{ border: "1px solid #000", padding: 6 }}>{form.client}</td>

                <td style={{ border: "1px solid #000", padding: 6 }}>LRQA Ref. No.:</td>
                <td style={{ border: "1px solid #000", padding: 6 }}>{form.lrqaRef}</td>
              </tr>

              <tr>
                <td style={{ border: "1px solid #000", padding: 6 }}>SUPPLIER:</td>
                <td style={{ border: "1px solid #000", padding: 6 }}>{form.supplier}</td>

                <td style={{ border: "1px solid #000", padding: 6 }}>INSPECTION LOCATION:</td>
                <td style={{ border: "1px solid #000", padding: 6 }}>{form.location}</td>
              </tr>

              <tr>
                <td style={{ border: "1px solid #000", padding: 6 }}>CONTACT:</td>
                <td style={{ border: "1px solid #000", padding: 6 }}>{form.contact}</td>

                <td style={{ border: "1px solid #000", padding: 6 }}>Concessions Apply:</td>
                <td style={{ border: "1px solid #000", padding: 6 }}>{form.concessionsApply}</td>
              </tr>

              <tr>
                <td style={{ border: "1px solid #000", padding: 6 }}>COMPLETE ORDER</td>
                <td style={{ border: "1px solid #000", padding: 6 }}>{form.completeOrder}</td>

                <td style={{ border: "1px solid #000", padding: 6 }}></td>
                <td style={{ border: "1px solid #000", padding: 6 }}></td>
              </tr>

              {/* TABLE HEADER */}
              <tr style={{ background: "#D5E6DE" }}>
                <th style={{ border: "1px solid #000", padding: 6 }}>PO ITEM NO.</th>
                <th style={{ border: "1px solid #000", padding: 6 }}>QTY</th>
                <th style={{ border: "1px solid #000", padding: 6 }}>ITEM DESCRIPTION</th>
                <th style={{ border: "1px solid #000", padding: 6 }}>TAG NO.</th>
              </tr>

              {form.equipmentRows.map((row, i) => (
                <tr key={i}>
                  <td style={{ border: "1px solid #000", padding: 6 }}>{row.poItem}</td>
                  <td style={{ border: "1px solid #000", padding: 6 }}>{row.qty}</td>
                  <td style={{ border: "1px solid #000", padding: 6 }}>{row.desc}</td>
                  <td style={{ border: "1px solid #000", padding: 6 }}>{row.tag}</td>
                </tr>
              ))}
            </table>
          </div>

          {/* ================= PAGE 2 ================= */}
          <div
            ref={pageRef2}
            style={{
              width: "210mm",
              minHeight: "297mm",
              padding: "20mm",
              background: "white",
              margin: "20px auto",
              boxShadow: "0 0 5px rgba(0,0,0,0.3)",
              fontFamily: "Arial",
            }}
          >
            <p><strong>Inspector’s Name:</strong> {form.inspectorName}</p>

            {form.signature && (
              <>
                <p><strong>Signature / Stamp:</strong></p>
                <img src={form.signature} alt="sign" style={{ width: 150 }} />
              </>
            )}

            <div
              style={{
                marginTop: 40,
                border: "2px solid #000",
                padding: 10,
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              THIS INSPECTION RELEASE NOTE IS NOT TO BE HANDED TO SUPPLIER WITHOUT CLIENT AGREEMENT
            </div>

            <p style={{ marginTop: 30, fontSize: 12 }}>
              LRQA, its subsidiaries and affiliates and their respective officers, employees or agents are, individually and collectively,
referred to in this clause as ‘LRQA’. LRQA assumes no responsibility and shall not be liable to any person for any loss,
damage or expense caused by reliance on the information or advice in this document or howsoever provided, unless that
person has signed a contract with the relevant LRQA entity for the provision of this information or advice and in that case
any responsibility or liability is exclusively on the terms and conditions set out in that contract.
            </p>

            <p style={{ marginTop: 40 }}>CD 61REV 5 </p>
          </div>

          {/* =================== FORM SECTION =================== */}

          <h2 style={{ marginTop: 40 }}>Fill Details</h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: 15,
              marginBottom: 20,
            }}
          >
            <input placeholder="Project Name/No" value={form.project} onChange={(e) => setForm({ ...form, project: e.target.value })} />
            <input placeholder="IRN No." value={form.irn} onChange={(e) => setForm({ ...form, irn: e.target.value })} />
            <input placeholder="PO/REF DOC" value={form.poRef} onChange={(e) => setForm({ ...form, poRef: e.target.value })} />
            <input placeholder="Date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} />

            <input placeholder="Client" value={form.client} onChange={(e) => setForm({ ...form, client: e.target.value })} />
            <input placeholder="LRQA Ref No" value={form.lrqaRef} onChange={(e) => setForm({ ...form, lrqaRef: e.target.value })} />
            <input placeholder="Supplier" value={form.supplier} onChange={(e) => setForm({ ...form, supplier: e.target.value })} />
            <input placeholder="Inspection Location" value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} />

            <input placeholder="Contact" value={form.contact} onChange={(e) => setForm({ ...form, contact: e.target.value })} />
          </div>

          <label><strong>Concessions Apply:</strong></label>
          <select value={form.concessionsApply} onChange={(e) => setForm({ ...form, concessionsApply: e.target.value })}>
            <option>YES</option>
            <option>NO</option>
          </select>

          <br /><br />

          <label><strong>Complete Order:</strong></label>
          <select value={form.completeOrder} onChange={(e) => setForm({ ...form, completeOrder: e.target.value })}>
            <option>YES</option>
            <option>NO</option>
          </select>

          <br /><br />

          <h2>Edit Equipment Table</h2>

          <table style={{ width: "100%", marginBottom: 20 }}>
            <thead>
              <tr>
                <th>PO ITEM NO.</th>
                <th>QTY</th>
                <th>ITEM DESCRIPTION</th>
                <th>TAG NO.</th>
              </tr>
            </thead>

            <tbody>
              {form.equipmentRows.map((row, i) => (
                <tr key={i}>
                  <td><input value={row.poItem} onChange={(e) => updateEquipment(i, "poItem", e.target.value)} /></td>
                  <td><input value={row.qty} onChange={(e) => updateEquipment(i, "qty", e.target.value)} /></td>
                  <td><input value={row.desc} onChange={(e) => updateEquipment(i, "desc", e.target.value)} /></td>
                  <td><input value={row.tag} onChange={(e) => updateEquipment(i, "tag", e.target.value)} /></td>
                </tr>
              ))}
            </tbody>
          </table>

          <button
            onClick={addRow}
            style={{
              padding: 10,
              background: "#222",
              color: "white",
              border: "none",
              marginBottom: 20,
            }}
          >
            + Add Row
          </button>

          <br />

          <label><strong>Upload Signature:</strong></label>
          <input type="file" accept="image/*" onChange={uploadSignature} />

          <br /><br />

          <button
            onClick={downloadPDF}
            style={{
              padding: 15,
              background: "green",
              color: "white",
              border: "none",
              cursor: "pointer",
            }}
          >
            Download PDF
          </button>
        </>
      )}
    </div>
  );
};

export default LRQAInspectionReleaseNote;
